import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(authenticated)/bulk-updates")({
  component: BulkUpdatesLayout,
})

function BulkUpdatesLayout() {
  return (
    <div className="h-full px-8">
      <Outlet />
    </div>
  )
}
